var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ComponentThemeProvider } from '../ThemeProvider';
import styled from '../utils/styled-components';
import { ButtonStyleBase, ButtonStyleRipple, ButtonStyleSize } from './index.styles';
import buttonTheme from './theme';
// Decides wich dom element is rendered
var ButtonComponent = function (_a) {
    var asLink = _a.asLink, asRouterLink = _a.asRouterLink, children = _a.children, 
    // remove this attributes from ...props to not appear in dom
    ripplePosition = _a.ripplePosition, theme = _a.theme, layout = _a.layout, uppercase = _a.uppercase, fullWidth = _a.fullWidth, 
    // --
    props = __rest(_a, ["asLink", "asRouterLink", "children", "ripplePosition", "theme", "layout", "uppercase", "fullWidth"]);
    if (asLink) {
        return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        React.createElement("a", __assign({ href: props.to }, props), children));
    }
    if (asRouterLink) {
        // eslint-disable-next-line react/jsx-props-no-spreading
        return React.createElement(Link, __assign({}, props), children);
    }
    // eslint-disable-next-line react/jsx-props-no-spreading, react/button-has-type
    return React.createElement("button", __assign({}, props), children);
};
// Apply styles to Button
var StyledButton = styled(ButtonComponent)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), ButtonStyleBase, ButtonStyleSize, function (_a) {
    var ripplePosition = _a.ripplePosition;
    return ripplePosition && ButtonStyleRipple;
});
/**
 * This component renders a button.<br />
 * Basic configuration:<br />
 * The `layout` prop controls the look of the rendered button according to the `ButtonLayout` type.<br />
 * The `size` prop controls the sizing of the rendered button. `medium` is the default value.<br />
 * The default width of the rendered button is determined by its children.<br />
 * There is a `fullWidth` prop to force rendering with 100% width inside its surrounding container.<br />
 * <p>For further options see the Props table on the Docspage or the `ButtonProps` type.</p>
 */
export var Button = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { return null; } : _b, children = _a.children, _c = _a.layout, layout = _c === void 0 ? 'default' : _c, noRipple = _a.noRipple, props = __rest(_a, ["onClick", "children", "layout", "noRipple"]);
    var _d = useState(), ripplePosition = _d[0], setRipplePosition = _d[1];
    return (React.createElement(ComponentThemeProvider, { theme: buttonTheme },
        React.createElement(StyledButton, __assign({ onClick: function (e) {
                if (!noRipple) {
                    setRipplePosition({
                        x: e.nativeEvent.offsetX,
                        y: e.nativeEvent.offsetY,
                    });
                }
                onClick(e);
            }, layout: layout, ripplePosition: ripplePosition }, props), children)));
};
export default Button;
var templateObject_1;
//# sourceMappingURL=index.js.map